var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 9.00055L8.09266 10.8155L11.7152 7.18555",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06266 1.83773C8.58016 1.39523 9.42766 1.39523 9.95266 1.83773L11.1377 2.85773C11.3627 3.05273 11.7827 3.21023 12.0827 3.21023H13.3577C14.1527 3.21023 14.8052 3.86273 14.8052 4.65773V5.93273C14.8052 6.22523 14.9627 6.65273 15.1577 6.87773L16.1777 8.06273C16.6202 8.58023 16.6202 9.42773 16.1777 9.95273L15.1577 11.1377C14.9627 11.3627 14.8052 11.7827 14.8052 12.0827V13.3577C14.8052 14.1527 14.1527 14.8052 13.3577 14.8052H12.0827C11.7902 14.8052 11.3627 14.9627 11.1377 15.1577L9.95266 16.1777C9.43516 16.6202 8.58766 16.6202 8.06266 16.1777L6.87766 15.1577C6.65266 14.9627 6.23266 14.8052 5.93266 14.8052H4.63516C3.84016 14.8052 3.18766 14.1527 3.18766 13.3577V12.0752C3.18766 11.7827 3.03016 11.3627 2.84266 11.1377L1.83016 9.94523C1.39516 9.42773 1.39516 8.58773 1.83016 8.07023L2.84266 6.87773C3.03016 6.65273 3.18766 6.23273 3.18766 5.94023V4.65023C3.18766 3.85523 3.84016 3.20273 4.63516 3.20273H5.93266C6.22516 3.20273 6.65266 3.04523 6.87766 2.85023L8.06266 1.83773Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.f06f38d9.svg";
export { ForwardRef as ReactComponent };